import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  TestCase,
  TestCaseBody
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onSuccess?: (response: TestCase) => void
  onError?: (error: Error) => void
  children?: (response: TestCase) => ReactElement
  params: TestCaseBody
}

const CreateModelerScriptTestCaseRequest = ({
  onSuccess,
  onError,
  children,
  params
}: Props) => {
  const url = `${MODELER_SERVICE}/test_cases/scripted`

  const { requestParams } = useGetParamsWithSpaceId<TestCaseBody>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default CreateModelerScriptTestCaseRequest
